import VueTab from '@ui-common/vue-tab';
export default {
	components: {
		VueTab
	}
};
